exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[data-v-4664c302] .app-address {\n  margin-top: 4px;\n  z-index: 1;\n}\n[data-v-4664c302] .area-tip {\n  color: #666;\n  margin-left: 10px;\n}\n", "", {"version":3,"sources":["/var/lib/jenkins/workspace/purang-shop-front-fun/buyer/src/views/goods/-goods-ship.vue"],"names":[],"mappings":";AACA;EACE,gBAAgB;EAChB,WAAW;CACZ;AACD;EACE,YAAY;EACZ,kBAAkB;CACnB","file":"-goods-ship.vue","sourcesContent":["\n[data-v-4664c302] .app-address {\n  margin-top: 4px;\n  z-index: 1;\n}\n[data-v-4664c302] .area-tip {\n  color: #666;\n  margin-left: 10px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-4664c302","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/goods/-goods-ship.vue
// module id = 3xbe
// module chunks = 10 11